// import external dependencies
import 'jquery';
import 'parsleyjs/dist/parsley.min';
import 'slick-carousel/slick/slick.min';
import 'jquery-fancybox/source/js/jquery.fancybox.pack';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
//import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,     // All pages
  //aboutUs,  // About Us page, note the change from about-us to aboutUs.
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/app.js